"use strict";
/**
A stripped-down console writer for inclusion in web client.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const chrome_1 = __importDefault(require("../formatters/chrome"));
const writer_1 = __importDefault(require("../common/writer"));
class WebConsoleWriter extends writer_1.default {
    constructor(deps = {}) {
        const options = deps.options || {};
        super(options);
        this.console = deps.console || console;
        this.formatter = deps.formatter || new chrome_1.default({ options });
    }
    write(obj, callback) {
        const text = this.formatter.format(obj);
        let colors = [];
        if (this.formatter.getChromeColors) {
            colors = this.formatter.getChromeColors(obj);
        }
        try {
            if (colors) {
                this.console.log.apply(this.console.log, [text].concat(colors));
            }
            else {
                this.console.log(text);
            }
            if (typeof callback === 'function')
                callback();
            return true;
        }
        catch (e) {
            try {
                // just in case this.console.log was used in a browser that doesn't support it
                this.console.log(text);
                return true;
            }
            catch (e) {
                if (typeof callback === 'function')
                    callback();
                return false;
            }
        }
    }
}
exports.default = WebConsoleWriter;
//# sourceMappingURL=web-console.js.map